import * as ActionTypes from '../constants';
import { baseUrl } from '.';
import axios from 'axios';
import { getUserToken } from './getUserToken';

const dispatchRequestLibrarySubjects = () => ({
    type: ActionTypes.REQUEST_LIBRARY_SUBJECTS
})

const dispatchReceivedLibrarySubjects = res => ({
    type: ActionTypes.RECEIVED_LIBRARY_SUBJECTS,
    res
})

const dispatchErrorLibrarySubjects = err => ({
    type: ActionTypes.ERROR_LIBRARY_SUBJECTS,
    err
})

const dispatchClearLibrarySubjects = () => ({
    type: ActionTypes.CLEAR_LIBRARY_SUBJECTS
})

export const clearLibrarySubjectsData = () => dispatchClearLibrarySubjects();


export const getLibrarySubjects = (id) => dispatch => { 
    getUserToken()
        .then(token => {
            dispatch(dispatchRequestLibrarySubjects());       
            const options = {
                method: 'post',
                url: `${baseUrl}/api/subjects_in_libray`,
                headers: {
                    Authorization: `Bearer ${token}`
                },
                data:{
                  exam_id: id
                }
            }         
            return axios(options).then( ({data}) => {
                dispatch(dispatchReceivedLibrarySubjects(data));
            })            
        }) 
        .catch(e => dispatch(dispatchErrorLibrarySubjects(e.response)));
}